export default __webpack_public_path__ + "static/media/Balaodefala.ee3c8fc1.png";